import { render, staticRenderFns } from "./AiThingCatalogThingsPage.vue?vue&type=template&id=476f3d8a&scoped=true&"
import script from "./AiThingCatalogThingsPage.vue?vue&type=script&lang=ts&"
export * from "./AiThingCatalogThingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./AiThingCatalogThingsPage.vue?vue&type=style&index=0&id=476f3d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f3d8a",
  null
  
)

export default component.exports